exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".gridlayout{background:none;width:100%;padding:15px 0 15px}.gridlayout-row{line-height:0;margin:0 -15px}.gridlayout-cell{display:inline-block;overflow:hidden;padding:15px}.gridlayout-cell .cropzoomimg-container{max-width:1200px}.gridlayout-hasMoreUrl{margin:2rem 0 2rem;text-align:center;width:100%}", ""]);

